import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import EditDeliveryVehicle from './EditDeliveryVehicle';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/messages';

function action({ store, params, intl }) {
  const title = intl.formatMessage(messages.editDeliveryVehicle);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  // Admin restriction
  if (!restrictUrls('/siteadmin/vehicle-type/edit/', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }
  return {
    title,
    component: (
      <AdminLayout>
        <EditDeliveryVehicle title={title} id={params.id} isAdmin={isAdminAuthenticated} />
      </AdminLayout>
    ),
  };
}

export default action;
